import 'dayjs/locale/es';
import "./Achievements.css";
import { useEffect, useState } from 'react';
import { fetchAchievementProgressForUser } from "../../apis/achievementsApi";
import { Carousel, Spin } from 'antd';
import { useParams } from 'react-router-dom';

const Achievements = () => {
  const { user_id } = useParams();
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadAchievements = async () => {
      setLoading(true);
      const result = await fetchAchievementProgressForUser(user_id);
      let visibleAchievements = []
      if(Array.isArray(result)){
        visibleAchievements = result.filter(a => a.secret !== 1);
      }
      setAchievements(visibleAchievements);
      setLoading(false);
    };
    loadAchievements();
  }, [user_id]);

  if (loading) {
    return (
      <div className="text-center mt-3">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="text-center mb-4">
        <div className="col-12 m-auto d-flex justify-content-center align-items-center" style={{ position: "relative" }}>
          {achievements.length > 0 && (
            <Carousel arrows={achievements.length > 1} infinite={true} style={{ maxWidth: "200px", minHeight: "130px" }}>
              {achievements
                .map((achievement, idx) => (
                  <div key={achievement.id || idx}>
                    <div style={{ height: "130px" }}>
                      <div
                        className="achievement-container m-auto themed-block mt-4 p-2 text-center"
                        data-toggle="tooltip"
                        data-placement="auto"
                        title={achievement.description || achievement.name}
                      >
                        <div className="d-flex flex-column mx-auto">
                          <div className="position-relative m-auto" style={{ width: "fit-content" }}>
                            {achievement.show_badge !== 0 && (
                              <span
                                className={
                                  "achievement-badge " +
                                  ((achievement.points === 0 || !achievement.points) ? "bg-locked" : "theme-inverted")
                                }
                              >
                                {achievement.points || 0}
                                {achievement.show_record ? `/${achievement.record || 0}` : ""}
                              </span>
                            )}
                            <img
                              className="achievement-icon"
                              src={
                                achievement.unlocked_at
                                  ? "/img/achievements/" + achievement.unlocked_img
                                  : "/img/achievements/" + achievement.locked_img
                              }
                              alt={achievement.name}
                            />
                          </div>
                          <p className="small">{achievement.name}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </Carousel>
          )}
        </div>
      </div>
  );
};

export default Achievements;
